import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()
export class MsjDialogService {
    constructor(private matSnackBar: MatSnackBar) { }
    openMensaje(mensaje:string,accion:string): void {
        this.matSnackBar.open(mensaje, accion, {
            duration: 2000,
            horizontalPosition:'center',
            direction:'ltr',
            verticalPosition:'bottom'
        });
    }
}